<template>
    <div class="p-4 text-sm text-gray-800">

        <p class="mb-3 text-xs text-gray-600">
            {{ __('I destinatari salvati con "salva in rubrica" dal modulo. Qui si correggono e si cancellano; quelli nuovi si aggiungono dal modulo.') }}
        </p>

        <!-- ============================================================ modifica -->
        <div v-if="modifica" ref="modifica" class="mb-4 p-3 border border-gray-400 rounded bg-gray-50">
            <div class="font-bold mb-2">{{ __('Modifica destinatario') }}</div>
            <div class="flex flex-wrap">
                <div class="md:w-1/2 w-full px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Nome o ragione sociale') }}</label>
                    <input v-model="modifica.ragionesociale" type="text" maxlength="30" :class="campo">
                </div>
                <div class="md:w-1/2 w-full px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Indirizzo') }}</label>
                    <input v-model="modifica.indirizzo" type="text" maxlength="30" :class="campo">
                </div>
                <div class="md:w-1/6 w-1/3 px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('CAP') }}</label>
                    <input v-model="modifica.cap" type="text" maxlength="5" inputmode="numeric" @input="capCambiato" :class="campo">
                </div>
                <div class="md:w-1/3 w-2/3 px-2 my-1">
                    <!-- solo le localita' del CAP: una localita' scritta a mano in rubrica
                         rientrerebbe in ogni spedizione e AS400 la rifiuterebbe -->
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Località') }}</label>
                    <select v-model="modifica.localita" :class="campo" :disabled="localita.length === 0">
                        <option v-if="localita.length === 0" value="">{{ __('scrivere un CAP di 5 cifre') }}</option>
                        <option v-for="l in localita" :key="l.localita" :value="l.localita">{{ l.localita }} ({{ l.prov }})</option>
                    </select>
                </div>
                <div class="md:w-1/2 w-full px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Riferimento destinatario') }}</label>
                    <input v-model="modifica.rif_destinatario" type="text" maxlength="40" :class="campo">
                </div>
                <div class="md:w-1/2 w-full px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Email destinatario per avviso tracking') }}</label>
                    <input v-model="modifica.email" type="text" maxlength="60" :class="campo">
                </div>
                <div class="md:w-1/2 w-full px-2 my-1">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1">{{ __('Note destinatario (es. orari di ricezione)') }}</label>
                    <input v-model="modifica.note_destinatario" type="text" maxlength="20" :class="campo">
                </div>
            </div>
            <div class="flex px-2 mt-2">
                <button type="button" @click="salva"
                    class="bg-red-600 hover:bg-red-800 text-white text-xs font-bold py-2 px-4 rounded mr-2">{{ __('salva') }}</button>
                <button type="button" @click="modifica = null"
                    class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded">{{ __('annulla') }}</button>
            </div>
        </div>

        <!-- ============================================================== elenco -->
        <div class="flex flex-wrap items-center mb-2">
            <input v-model="cerca" type="text" maxlength="40" :placeholder="__('cerca nome, indirizzo, località, riferimento...')"
                class="text-xs w-72 bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-2 mr-3 focus:outline-none focus:bg-white focus:border-gray-500">
            <span class="text-xs text-gray-600">{{ filtrate.length }} / {{ voci.length }} {{ __('destinatari') }}</span>
        </div>

        <div class="w-full overflow-x-auto">
            <table class="min-w-full text-xs">
                <thead>
                    <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                        <th class="px-2 py-2">{{ __('Nome') }}</th>
                        <th class="px-2 py-2">{{ __('Indirizzo') }}</th>
                        <th class="px-2 py-2">{{ __('Località') }}</th>
                        <th class="px-2 py-2">{{ __('Riferimento') }}</th>
                        <th class="px-2 py-2">{{ __('Email') }}</th>
                        <th class="px-2 py-2">{{ __('Note dest.') }}</th>
                        <th class="px-2 py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="v in filtrate" :key="v.id" class="border-b border-gray-200 align-top"
                        :class="{ 'bg-yellow-50': modifica && modifica.id === v.id }">
                        <td class="px-2 py-2 font-medium">{{ v.ragionesociale }}</td>
                        <td class="px-2 py-2">{{ v.indirizzo }}</td>
                        <td class="px-2 py-2 whitespace-nowrap">{{ v.cap }} {{ v.localita }} ({{ v.prov }})</td>
                        <td class="px-2 py-2">{{ v.rif_destinatario }}</td>
                        <td class="px-2 py-2">{{ v.email }}</td>
                        <td class="px-2 py-2">{{ v.note_destinatario }}</td>
                        <td class="px-2 py-2 whitespace-nowrap text-right">
                            <button type="button" @click="apri(v)"
                                class="text-xs font-bold py-1 px-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-800 mr-1">{{ __('modifica') }}</button>
                            <button type="button" @click="chiediElimina(v)"
                                class="text-xs font-bold py-1 px-2 rounded bg-red-600 hover:bg-red-800 text-white">{{ __('elimina') }}</button>
                        </td>
                    </tr>
                    <tr v-if="filtrate.length === 0">
                        <td colspan="7" class="px-2 py-4 text-gray-500">
                            {{ voci.length === 0 ? __('La rubrica è vuota: i destinatari si salvano dal modulo con "salva in rubrica".') : __('Nessun destinatario trovato.') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="voci.length >= max" class="text-xs text-gray-500 mt-1">{{ __('mostrati i primi') }} {{ max }}</div>

        <Modal :modal="modal"></Modal>
    </div>
</template>

<script>
import Modal from './utility/Modal.vue';

/**
 * Scheda "Rubrica" di Crea Spedizioni (13/10/2026): destinatari della bollettazione
 * (ritiro_rubrica, tipor 'c') del cliente loggato. Vedere, correggere, cancellare.
 * Le voci nuove si creano dal modulo con "salva in rubrica".
 * La ricerca e' fatta qui sulla lista gia' caricata: le rubriche sono piccole.
 */
export default {
    components: { Modal },
    data() {
        return {
            voci: [],
            max: 5000,
            cerca: '',
            modifica: null,
            localita: [],
            modal: { show: false, title: '', body: [], buttons: undefined },
            campo: 'text-xs appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded px-3 py-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500'
        };
    },
    computed: {
        filtrate() {
            const t = this.cerca.trim().toUpperCase();
            if (!t) return this.voci;
            return this.voci.filter(v => [v.ragionesociale, v.indirizzo, v.cap, v.localita, v.prov,
                v.rif_destinatario, v.email, v.note_destinatario]
                .some(x => String(x || '').toUpperCase().includes(t)));
        }
    },
    methods: {
        uri(p) {
            return this.$store.getters.uri + '/bollettazione/' + p;
        },
        async carica() {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(() => this.axios.post(this.uri('rubrica'), {}), false);
                const v = res && res.value ? res.value : res;
                if (v && Array.isArray(v.voci)) {
                    this.voci = v.voci;
                    this.max = v.max || this.max;
                }
                return res;
            });
        },
        async apri(v) {
            this.modifica = Object.assign({}, v);
            this.localita = [];
            await this.caricaLocalita(v.cap);
            this.$nextTick(() => {
                if (this.$refs.modifica && this.$refs.modifica.scrollIntoView) {
                    this.$refs.modifica.scrollIntoView({ block: 'start', behavior: 'smooth' });
                }
            });
        },
        capCambiato() {
            this.modifica.cap = String(this.modifica.cap || '').replace(/\D/g, '').slice(0, 5);
            this.localita = [];
            this.modifica.localita = '';
            if (this.modifica.cap.length === 5) this.caricaLocalita(this.modifica.cap);
        },
        async caricaLocalita(cap) {
            const c = String(cap || '').replace(/\D/g, '');
            if (c.length !== 5) return;
            const res = await this.handleCallback(
                () => this.axios.post(this.uri('rubrica-localita'), { cap: c }), false, true, false);
            const v = res && res.value ? res.value : res;
            this.localita = v && Array.isArray(v.localita) ? v.localita : [];
            // una sola localita' per quel CAP: si sceglie da sola
            if (this.modifica && !this.localita.some(l => l.localita === this.modifica.localita)) {
                this.modifica.localita = this.localita.length === 1 ? this.localita[0].localita : '';
            }
        },
        async salva() {
            if (!this.modifica) return;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(() => this.axios.post(this.uri('rubrica-salva'), this.modifica), false);
                if (res && res.id) {
                    this.$emit('notify', true, this.__('Destinatario salvato'));
                    this.modifica = null;
                    await this.carica();
                }
                return res;
            });
        },
        chiediElimina(v) {
            const esc = t => String(t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            this.modal = {
                show: true,
                title: this.__('Eliminare il destinatario dalla rubrica?'),
                body: [{
                    value: '<b>' + esc(v.ragionesociale) + '</b><br>' + esc(v.indirizzo) + ' - '
                        + esc(v.cap) + ' ' + esc(v.localita) + ' (' + esc(v.prov) + ')'
                        + '<br><br>' + this.__('Le spedizioni già fatte non cambiano.'),
                    action: () => {}
                }],
                buttons: [
                    { title: this.__('elimina'), click: () => { this.modal.show = false; this.elimina(v.id); } },
                    { title: this.__('annulla'), click: () => { this.modal.show = false; } }
                ]
            };
        },
        async elimina(id) {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(() => this.axios.post(this.uri('rubrica-elimina'), { id }), false);
                if (res) {
                    if (this.modifica && this.modifica.id === id) this.modifica = null;
                    this.$emit('notify', true, this.__('Destinatario eliminato'));
                    await this.carica();
                }
                return res;
            });
        }
    }
};
</script>
